// extracted by mini-css-extract-plugin
export default {"btn":"Login_btn__JWk2S"};